import { render, staticRenderFns } from "./objImageSelected.vue?vue&type=template&id=fe3cf04c&"
import script from "./objImageSelected.vue?vue&type=script&lang=ts&"
export * from "./objImageSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports